import VilgramFileDto from "../../../../../../dto/VilagramFileDto"

export enum ActionType {
    BOOKMARK_SHOW = 'BOOKMARK_SHOW'

}

export interface ActionBookmark {
    type: ActionType.BOOKMARK_SHOW
}

type Action = ActionBookmark

export default Action